import {
    GET_SINGLE_UNIT_DETAILS_REQUEST,
    GET_SINGLE_UNIT_DETAILS_SUCCESS,
    GET_SINGLE_UNIT_DETAILS_FAILURE
} from '../actions/index';


const initialState = {};

const SingleUnitDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SINGLE_UNIT_DETAILS_REQUEST:
            return Object.assign({},state, {asyncStatus:  'PENDING'});
        case GET_SINGLE_UNIT_DETAILS_SUCCESS:
            return Object.assign({},state, {asyncStatus:  'SUCCESS', data: action.payload});
        case GET_SINGLE_UNIT_DETAILS_FAILURE:
            return Object.assign({},state, {asyncStatus:  'FAILURE', data: action.payload});
        default:
            return state;
    }
};

export default SingleUnitDetailsReducer;